import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"minus\">\n<path d=\"M7 0C3.13306 0 0 3.13306 0 7C0 10.8669 3.13306 14 7 14C10.8669 14 14 10.8669 14 7C14 3.13306 10.8669 0 7 0ZM3.27419 8.12903C3.0879 8.12903 2.93548 7.97661 2.93548 7.79032V6.20968C2.93548 6.02339 3.0879 5.87097 3.27419 5.87097H10.7258C10.9121 5.87097 11.0645 6.02339 11.0645 6.20968V7.79032C11.0645 7.97661 10.9121 8.12903 10.7258 8.12903H3.27419Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol